<template>
  <div id="sideNav" ref="sideNav">
    <!-- 水平 -->
    <div
      v-if="type === 'horizontal'"
      class="sideNav px-0 main-background-color sideNav-active"
      :class="{
        'sideNav-show': sideNavTrigger,
        'sideNav-hide': !sideNavTrigger,
      }"
    >
      <ul
        class=""
        style="padding: 0px; height: calc(100% - 53px); overflow: auto"
      >
        <sidebarItem
          v-for="(item, key) in sideBar"
          :key="key"
          :item="item"
          :itemKey="key"
          :path="[key]"
          :itemOrgKey="key"
          :type="type"
        />
      </ul>
      <p
        class="main-color index-version"
        style="
          background-color: transparent;
          padding: 0px;
          cursor: auto;
          position: absolute;
          bottom: 0px;
          left: 70.547px;
          font-size: 14px;
          font-family: 'dfyuanstd-w7';
        "
      >
        Ver {{ version }}
      </p>
    </div>
    <!-- 垂直 -->
    <div
      v-if="type == 'vertical'"
      class="sideNav px-0 main-background-color sideNav-active"
      :class="{
        'sideNav-show': sideNavTrigger,
        'sideNav-hide': !sideNavTrigger,
      }"
      style="position: absolute"
    >
      <ul
        class=""
        style="
          padding: 0px;
          height: calc(100% - 120px);
          overflow: auto;
          margin-bottom: 0px;
        "
      >
        <sidebarItem
          v-for="(item, key) in sideBar"
          :key="key"
          :item="item"
          :itemKey="key"
          :path="[key]"
          :itemOrgKey="key"
          :type="type"
          :colorArray="colorArray"
          :deep="0"
        />
      </ul>
      <div
        class="main-color index-version"
        style="
          background-color: transparent;
          padding: 0px;
          cursor: auto;
          font-size: 14px;
          font-family: dfyuanstd-w7;
          line-height: 40px;
          padding: 0 25px;
        "
      >
        <div class="side-navbar-username" style="">
          <greetingUser></greetingUser>
        </div>
        <div class="d-flex justify-content-between">
          <signOut></signOut>
        </div>
        <div style="border-top: 1px solid #646569; margin-top: 12px">
          Ver {{ version }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, inject, onUnmounted, provide, ref, watch } from "vue";
import sidebarItem from "@/components/sidebarItem";
import greetingUser from "@/components/greetingUser.vue";
import signOut from "@/components/signOut.vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

export default {
  props: {
    type: {
      type: String,
      default: "horizontal",
    },
  },
  components: { sidebarItem, greetingUser, signOut },
  setup(props) {
    const sideNavTrigger = inject("sideNavTrigger");
    const reurnToHome = inject("reurnToHome");
    const sideNavPath = ref([]);
    const currentRoute = useRoute();
    const allChildHide = ref(0);
    const isActivePage = ref(currentRoute.name);
    const version = "2.0";

    const store = useStore();
    const sideBar = computed(() => store.getters["sideBarTree/get_sideBar"]);
    // const sidebar = {
    //   home: {
    //     name: "總覽",
    //     right: "R",
    //     children: {
    //       homeforging3: {
    //         name: "鍛造三部",
    //         right: "R",
    //         children: {},
    //       },
    //     },
    //   },
    //   elecboard: {
    //     name: "即時看板",
    //     right: "R",
    //     children: {
    //       elecboardforging3: {
    //         name: "鍛造三部",
    //         right: "R",
    //         children: {
    //           preheating: {
    //             name: "保溫爐",
    //             right: "R",
    //             children: {},
    //           },
    //           heating: {
    //             name: "加熱爐",
    //             right: "R",
    //             children: {},
    //           },
    //         },
    //       },
    //     },
    //   },
    //   activation: {
    //     name: "稼動率",
    //     right: "R",
    //     children: {},
    //   },
    // };

    //dispatch
    const methods = {
      set_sideBarSelect: (payload) => {
        store.dispatch("sideBarTree/set_sideBarSelect", payload);
      },
    };

    const setSessionItems = () => {
      //儲存session
      sessionStorage.setItem(
        "mesSideBarItem",
        JSON.stringify([sideNavTrigger.value, sideNavPath.value])
      );
    };

    window.addEventListener("beforeunload", setSessionItems);

    const sessionSideBarItem = JSON.parse(
      sessionStorage.getItem("mesSideBarItem")
    );
    sessionStorage.removeItem("mesSideBarItem");
    if (sessionSideBarItem != null) {
      const setSideBarItem = sessionSideBarItem.filter((el) => el);
      if (setSideBarItem.length != 0) {
        methods.set_sideBarSelect(sessionSideBarItem[1]);
        sideNavTrigger.value = sessionSideBarItem[0];
        sideNavPath.value = sessionSideBarItem[1];
      } else {
        sideNavPath.value = ["home", "homeall"];
        methods.set_sideBarSelect(sideNavPath.value);
      }
    } else {
      sideNavPath.value = ["home", "homeall"];
      methods.set_sideBarSelect(sideNavPath.value);
    }

    //找最大遞迴層數
    const calculateMaxDepth = (data) => {
      let maxDepth = 0;

      const traverse = (item, depth) => {
        if (depth > maxDepth) {
          maxDepth = depth;
        }
        if (item == undefined) {
          return;
        }
        if (item.children && Object.keys(item.children).length > 0) {
          for (const childKey in item.children) {
            traverse(item.children[childKey], depth + 1);
          }
        }
      };

      for (const key in data) {
        traverse(data[key], 1);
      }
      return maxDepth;
    };
    const maxDeep = ref(calculateMaxDepth(sideBar.value));

    // 生成顏色漸變陣列
    const generateColorGradient = (startColor, endColor, steps) => {
      const colors = [];

      // 將起始顏色和結束顏色轉換為 RGB 值
      const startRGB = hexToRGB(startColor);
      const endRGB = hexToRGB(endColor);

      // 計算每個步驟的顏色
      const stepR = (endRGB.r - startRGB.r) / steps;
      const stepG = (endRGB.g - startRGB.g) / steps;
      const stepB = (endRGB.b - startRGB.b) / steps;

      // 生成漸變顏色陣列
      for (let i = 0; i <= steps; i++) {
        const r = Math.round(startRGB.r + stepR * i);
        const g = Math.round(startRGB.g + stepG * i);
        const b = Math.round(startRGB.b + stepB * i);
        const color = RGBToHex(r, g, b);
        colors.push(color);
      }

      return colors;
    };

    // 將十六進位顏色轉換為 RGB 物件
    const hexToRGB = (hex) => {
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      return { r, g, b };
    };

    // 將 RGB 值轉換為十六進位顏色
    const RGBToHex = (r, g, b) => {
      const hexR = r.toString(16).padStart(2, "0");
      const hexG = g.toString(16).padStart(2, "0");
      const hexB = b.toString(16).padStart(2, "0");
      return `#${hexR}${hexG}${hexB}`;
    };

    // 生成顏色陣列
    const colorArray = ref(
      generateColorGradient("#c8c9ca", "#FFFFFF", maxDeep.value)
    );

    //重新設置顏色陣列
    watch(
      sideBar,
      () => {
        colorArray.value = generateColorGradient(
          "#c8c9ca",
          "#FFFFFF",
          maxDeep.value
        );
      },
      { deep: true }
    );

    //記錄使用者點擊項目
    watch(sideNavPath, (newValue) => {
      methods.set_sideBarSelect(newValue);
    });

    //使用者點擊返回首頁，修改鎖定頁面(isActivePage)
    watch(reurnToHome, (newValue) => {
      if (newValue == true) {
        isActivePage.value = "home";
        reurnToHome.value = false;
      }
    });

    watch(
      () => props.type,
      (newValue) => {
        if (newValue === "horizontal") {
          isActivePage.value = currentRoute.name;
        }
      },
      { deep: true }
    );

    provide("sideNavPath", sideNavPath);
    provide("allChildHide", allChildHide);
    provide("isActivePage", isActivePage);

    onUnmounted(() => {
      window.removeEventListener("beforeunload", setSessionItems);
    });
    return {
      sideNavTrigger,
      sideBar,
      colorArray,
      version,
    };
  },
};
</script>

<style>
.sideNav-show {
  position: relative;
  transform: translate3d(0, 0, 0);
}
.sideNav-hide {
  position: absolute;
  transform: translate3d(-100%, 0, 0);
}
.sideNav-active {
  transition: all 0.2s;
}
.sideNav {
  width: 200px;
  height: calc(100vh - 60px);
  text-align: center;
  z-index: 50;
}
.sideNav::-webkit-scrollbar {
  display: none;
}
.sideNav a {
  display: block;
  color: #000;
  text-decoration: none;
  font-size: 20px;
}
.sideNav .sideNav-list {
  color: #646569;
  border-bottom: 2px solid #646569;
  width: 165px;
  height: 60px;
  line-height: 60px;
  font-size: 22px;
  font-family: dfyuanstd-w8, dfyuanstd-w7, dfyuanstd-w5;
  margin: auto;
}
.sideNav li:hover,
.sideNav li:hover > .sideNav-list,
.sideNav a:hover > .sideNav-list {
  color: var(--main-font-color);
  background: #646569;
}
.sideNav .active > a:first-child,
.sideNav .active > a:first-child .sideNav-list,
.sideNav li.active,
.sideNav .active > div:first-child {
  background: #646569;
  color: var(--main-font-color);
}
.sideNav li {
  font-family: "dfyuanstd-w8";
  display: block;
  position: relative;
  background: #c8c9ca;
  color: #646569;
  cursor: pointer;
  height: 60px;
}
.sideNav li ul {
  position: absolute;
  left: 200px;
  width: 200px;
  top: 0px;
  margin: 0;
  padding: 0;
  z-index: 2;
}
.side-navbar-username {
  width: auto;
  font-size: 16px;
  text-align: left;
  /* color: var(--main-font-color); */
}
.side-navbar-button {
  background-color: var(--main-bg-color);
  width: 64px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  color: #eefbf0;
}
/* On small screens, set height to 'auto' for sideNav and grid */
@media screen and (max-width: 992px) {
  .sideNav li:hover,
  .sideNav li:hover > .sideNav-list,
  .sideNav a:hover > .sideNav-list {
    color: #646569;
    background: none;
  }
}
</style>
